import React from 'react';
import Grid from '@material-ui/core/Grid';
import TagManager from 'react-gtm-module';
import Cookies from 'universal-cookie';
import base64 from 'base-64';

import Item from '../../../../../../../util/Item/.mixins/Item';
import ItemHelp from '../../../../../../../util/ItemHelp/.mixins/ItemHelp';
import { Can } from '../../../../../../../util/Can';

export default (props) => {

    const goTo = (props,link) => {
        const cookies = new Cookies();
        const ga_informations = cookies.get('ga_informations');

        props.props.router.push(link);

        // prepara variavel para module
        let abaModule = link.replace("/","");
        abaModule = (abaModule==="")?"inicio":abaModule;
        abaModule = abaModule.replace(/[A-Z]/g, m => "-" + m.toLowerCase());

        TagManager.dataLayer({
            dataLayer: {
                event: 'event',
                eventCategory: 'tokstok:fornecedores:inicio',
                eventAction: 'clique:botao',
                eventLabel: abaModule,
            }
        });

        if (ga_informations) {
            TagManager.dataLayer({dataLayer: JSON.parse(base64.decode(ga_informations))});
        }
    };
    
    return (
        <div>
            <Grid container spacing={1}>
                <Can some permissions={["lista-de-pedidos-pendentes", "nova-tela-pedidos-pendentes"]}>
                    <Grid item sm={4} xs={12}>
                        <a onClick={(e) => {
                        if (props.permissions["nova-tela-pedidos-pendentes"])
                            goTo(props,'pendentesNova');
                        else
                            goTo(props,'pendentes');
                        }}>
                            <Item title='Pedidos não agendados' icone='alarm' />
                        </a>
                    </Grid>
                </Can>

                <Can permissions={["lista-de-pedidos-agendados"]}>
                    <Grid item sm={4} xs={12}>
                        <a onClick={(e) => {goTo(props,'agendados')}}>
                            <Item title='Pedidos agendados' icone='calendar_today' />
                        </a>
                    </Grid>
                </Can>

                <Can permissions={["lista-de-pagamentos"]}>
                    <Grid item sm={4} xs={12}>
                        <a onClick={(e) => {goTo(props,'pagamentos')}}>
                            <Item title='Pagamentos' icone='attach_money' />
                        </a>
                    </Grid>
                </Can>

                <Can permissions={["lista-de-notas"]}>
                    <Grid item sm={4} xs={12}>
                        <a onClick={(e) => {goTo(props,'notas')}}>
                            <Item title='Nota Fiscal' icone='receipt'/>
                        </a>
                    </Grid>
                </Can>

                <Can permissions={["protocolo-de-agendamento"]}>
                    <Grid item sm={4} xs={12}>
                        <a onClick={(e) => {goTo(props,'protocolos')}}>
                            <Item title='Protocolos de agendamento' icone='assignment'/>
                        </a>
                    </Grid>
                </Can>

                <Grid item sm={4} xs={12}>
                    <ItemHelp 
                        title1='Em caso de dúvidas, '
                        title2='Em caso de problemas com o portal, '
                        icone='mail'
                    />
                </Grid>
            </Grid>                    
        </div>
    );
};
